var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "#FFCF61",
    d: "m22.98551,0.13904c-12.63776,0 -22.81448,10.24323 -22.81448,22.81448c0,12.63776 10.24323,22.81448 22.81448,22.81448s22.81448,-10.24323 22.81448,-22.81448c0.06651,-12.57124 -10.17672,-22.81448 -22.81448,-22.81448zm11.30747,32.45908l-4.78904,0l0,-6.85099l-12.30518,7.18357l0,-20.02087l12.30518,7.18357l0,-6.85099l4.78904,0l0,19.35572z",
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNext);
export default __webpack_public_path__ + "static/media/music-next.7a58c29dc4cfc2f31501ded326f2f411.svg";
export { ForwardRef as ReactComponent };